export type CircleSize = "xxxxs" | "xs" | "sm" | "md" | "lg" | "xl";
export const CircleSizeTable: Record<CircleSize, number> = {
  xxxxs: 8,
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32
};
